export const CustomerTypeEnums = [
  {
    value: '0',
    label: 'Chọn kiểu khách hàng',
  },
  {
    value: '1',
    label: 'Công ty',
  },
  {
    value: '2',
    label: 'Cá nhân',
  },
]

export const PayeeType = [
  {value: '0', label: 'Chọn'},
  {value: '1', label: 'Cá nhân'},
  {value: '2', label: 'Tổ chức'},
  // {value: 3, label: 'Người bán'},
  {value: '4', label: 'Người mua'},
  {value: '5', label: 'Ngân hàng'},
]

// const items = localStorage.getItem('CommonCode')

// export const CustomerSource: any = items ? JSON.parse(items) : []

// export const CustomerSegmentType: any = items ? JSON.parse(items).filter((o: any) => o.type == 0) : []
export const CustomerSegmentType = [
  {value: '0', label: 'Bình thường'},
  {value: '1', label: 'VIP'},
]

export const ApproveType = [
  {value: '1', label: 'Tuần tự'},
  {value: '2', label: 'Đồng thời'},
]

export const CustomerSegmentTypeEnterprise = [
  {value: '6', label: 'Doanh nghiệp nhỏ'},
  {value: '5', label: 'Doanh nghiệp vừa'},
  {value: '7', label: 'Doanh nghiệp lớn'},
  {value: '10', label: 'Doanh nghiệp nhà nước'},
]

export const CustomerSource = [
  {value: '0', label: 'Chọn nguồn'},
  {value: '1', label: 'Selling'},
]

export const ContractSource = [
  {value: '0', label: 'Chọn nguồn'},
  {value: 'LDP', label: 'LandingPage'},
  {value: 'MOBILE', label: 'Mobile'},
  {value: 'BANCASS', label: 'Bancass'},
  {value: 'PORTAL', label: 'Portal'},
]

export const GenderEnums = [
  {
    value: 0,
    label: 'Chọn giới tính',
  },
  {
    value: 1,
    label: 'Nam',
  },
  {
    value: 2,
    label: 'Nữ',
  },
]

export const LanguageStep1Enums = [
  {
    value: 'vie',
    label: 'Tiếng Việt',
  },
  {
    value: 'en',
    label: 'Tiếng Anh',
  },
  {
    value: 'both',
    label: 'Song ngữ',
  },
]

export const ObjectInsuredType = [
  {
    value: 0,
    label: 'Chọn',
  },
  {
    value: 1,
    label: 'Đang trình',
  },
  {
    value: 2,
    label: 'Đang ký',
  },
  {
    value: 3,
    label: 'Đã ký',
  },
  {
    value: 4,
    label: 'Hủy',
  },
  {
    value: 5,
    label: 'Chấm dứt',
  },
]

export const ObjectInsuredTerminateType = [
  {
    value: 0,
    label: 'Chọn',
  },
  {
    value: 5,
    label: 'Chấm dứt',
  },
]

export const TPAType = [
  {
    value: 0,
    label: 'Chọn kiểu tpa',
  },
  {
    value: 1,
    label: 'INSMART',
  },
  {
    value: 2,
    label: 'ESCS',
  },
]

export const ExploitingType = [
  {
    value: 0,
    label: 'Chọn kiểu khai thác',
  },
  {
    value: 2,
    label: 'Qua đại lý',
  },
  {
    value: 3,
    label: 'Môi giới',
  },
  {
    value: 4,
    label: 'Nhận đồng bảo hiểm',
  },
  {
    value: 5,
    label: 'Nhận tái bảo hiểm',
  },
  // {
  //   value: 1,
  //   label: 'Tự khai thác',
  // },
]

export const ContractPackageType = [
  {
    value: 0,
    label: 'Chọn kiểu hợp đồng',
  },
  {
    value: 1,
    label: 'Đang trình',
  },
  {
    value: 2,
    label: 'Đã duyệt',
  },
  {
    value: 3,
    label: 'Từ chối',
  },
]

export const ContractType = [
  {
    value: 0,
    label: 'Chọn kiểu hợp đồng',
  },
  {
    value: 1,
    label: 'Hợp đồng gốc',
  },
  {
    value: 2,
    label: 'Sửa đổi bổ sung',
  },
]

export const ContractKind = [
  {
    value: 0,
    label: 'Chọn loại hợp đồng',
  },
  {
    value: 1,
    label: 'Hợp đồng mới',
  },
  {
    value: 3,
    label: 'Tái tục',
  },
  {
    value: 4,
    label: 'Hợp đồng bao/nguyên tắc',
  },
  {
    value: 5,
    label: 'Hợp đồng mới theo HĐ nguyên tắc',
  },
]

export const ContractKindEng = [
  {
    value: 0,
    label: 'All',
  },
  {
    value: 1,
    label: 'New Contract',
  },
  {
    value: 3,
    label: 'Renewals',
  },
  {
    value: 4,
    label: 'Master Contract',
  },
  {
    value: 5,
    label: 'Contract by Master Contract',
  },
]

export const ConfigLdp = [
  {
    value: 'no',
    label: 'Không',
  },
  {
    value: 'yes',
    label: 'Có',
  },
]

export const ConfigYesNo = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: 'no',
    label: 'Không',
  },
  {
    value: 'yes',
    label: 'Có',
  },
]

export const PackageInsuredType = [
  {
    value: 'STAFF',
    label: 'Nhân viên',
  },
  {
    value: 'DEP',
    label: 'Người phụ thuộc',
  },
]

export const FeeInsurance = [
  {
    value: '10000000',
    label: '10,000,000',
  },
  {
    value: '12000000',
    label: '12,000,000',
  },
  {
    value: '20000000',
    label: '20,000,000',
  },
  {
    value: '30000000',
    label: '30,000,000',
  },
  {
    value: '40000000',
    label: '40,000,000',
  },
  {
    value: '50000000',
    label: '50,000,000',
  },
  {
    value: '60000000',
    label: '60,000,000',
  },
  {
    value: '70000000',
    label: '70,000,000',
  },
  {
    value: '80000000',
    label: '80,000,000',
  },
  {
    value: '90000000',
    label: '90,000,000',
  },
  {
    value: '100000000',
    label: '100,000,000',
  },
  {
    value: '200000000',
    label: '200,000,000',
  },
  {
    value: '300000000',
    label: '300,000,000',
  },
]

export const ContractPackageTypeApprove = [
  {
    value: 1,
    label: 'Vượt phân cấp',
  },
  {
    value: 2,
    label: 'Đang trình',
  },
  {
    value: 3,
    label: 'Đã duyệt',
  },
  {
    value: 4,
    label: 'Từ chối',
  },
]

export const CertificateType = [
  {
    value: '1',
    label: 'Điện tử',
  },
  {
    value: '2',
    label: 'Truyền thống',
  },
]

export const CoverageType = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: '1',
    label: 'Trong nước',
  },
  {
    value: '2',
    label: 'Nước ngoài',
  },
]

export const ReportTypes = [
  {
    value: 'ReportRevenuePayment',
    label: 'Doanh thu thực thu - Nhóm theo hợp đồng',
  },
  {
    value: 'ReportRevenueSales',
    label: 'Doanh thu bán hàng - Nhóm theo hợp đồng',
  },
  {
    value: 'ReportPaymentIncurreds',
    label: 'Doanh thu phát sinh - Nhóm theo hợp đồng',
  },
  {
    value: 'ReportDebtHasGeneratedSales',
    label: 'Công nợ khách hàng đã phát sinh doanh thu bán hàng',
  },
  {
    value: 'ReportDebtHasNotGeneratedSales',
    label: 'Công nợ khách hàng chưa phát sinh doanh thu bán hàng',
  },
  {
    value: 'ReportPaymentIncurredDetail',
    label: 'Doanh thu phát sinh chi tiết - Chi tiết theo quyền lợi bảo hiểm',
  },
  {
    value: 'ReportRevenuePaymentDetail',
    label: 'Doanh thu thực thu chi tiết - Chi tiết theo quyền lợi bảo hiểm',
  },
  {
    value: 'ReportRevenueSaleDetail',
    label: 'Doanh thu bán hàng chi tiết - Chi tiết theo quyền lợi bảo hiểm',
  },
  {
    value: 'ReportCommissionBacklock',
    label: 'Công nợ hoa hồng',
  },
  {
    value: 'ReportCommissionPayment',
    label: 'Hoa hồng đã chi',
  },
  {
    value: 'ReportCommissionBacklockDetail',
    label: 'Công nợ hoa hồng (Theo quyền lợi chi tiết)',
  },
  {
    value: 'ReportCommissionPaymentDetail',
    label: 'Hoa hồng đã chi (Theo quyền lợi chi tiết)',
  },
  {
    value: 'ReportContractTreaty',
    label: 'Báo cáo theo hợp đồng nguyên tắc',
  },
  {
    value: 'ReportContractPaymentRemind',
    label: 'Báo cáo hợp đồng đến hạn thu phí',
  },
  {
    value: 'ReportMasterPolicy',
    label: 'Báo cáo đơn Master',
  },
  {
    value: 'ReportRenewPolicy',
    label: 'Báo cáo tái tục',
  },
  {
    value: 'ReportInstalmentMonth',
    label: 'Báo cáo Installment tháng',
  },
  {
    value: 'ReportRevenueForAccounting',
    label: 'Báo cáo cho kế toán',
  },
  {
    value: 'ReportByBenefitPayment',
    label: 'Báo cáo doanh thu theo quyền lợi',
  },
  {
    value: 'ReportByBenefitPayment',
    label: 'Báo cáo phí phát sinh theo quyền lợi',
  },
  {
    value: 'ReportByBenefitPaymentRevenue',
    label: 'Báo cáo phí thực nhận theo quyền lợi',
  },
  {
    value: 'ReportByAgePayment',
    label: 'Báo cáo phí phát sinh theo độ tuổi',
  },
  {
    value: 'ReportByAgePaymentRevenue',
    label: 'Báo cáo phí thực nhận theo độ tuổi',
  },
  {
    value: 'ReportForVATInvoice',
    label: 'Báo cáo xuất hóa đơn',
  },
  {
    value: 'ReportForVehiclePhysical',
    label: 'Báo cáo kết quả kinh doanh bảo hiểm vật chất xe cơ giới',
  },
  {
    value: 'ReportForVehicleInsurance',
    label: 'Báo cáo tình hình hiệu lực hợp đồng bảo hiểm các loại xe cơ giới theo kỳ',
  },
  {
    value: 'ReportForVehicleInsuranceD',
    label: 'Báo cáo tình hình hiệu lực hợp đồng bảo hiểm chi tiết các loại xe cơ giới theo kỳ',
  },
  {
    value: 'ReportRevenuePaymentNetwork',
    label: 'Báo cáo doanh thu trên môi trường mạng',
  },
  {
    value: 'PNT_01',
    label: 'Báo cáo lũy kế',
  },
  {
    value: 'PNT_02',
    label: 'Báo cáo nhận tái/ nhượng tái bảo hiểm',
  },
  {
    value: 'PNT_03',
    label: 'Báo cáo so  sánh doanh thu cùng kỳ',
  },
  {
    value: 'ReportForInsuranceBusiness',
    label: 'Báo cáo kinh doanh bảo hiểm',
  },
  {
    value: 'ReportGeneral',
    label: 'Báo cáo General',
  },
  {
    value: 'REPORT_TNDS_XCG',
    label: 'BÁO CÁO TNDS BB XE CƠ GIỚI',
  },
  {
    value: 'MS1',
    label: 'BÁO CÁO BẢO HIỂM BẮT BUỘC TNDS CỦA CHỦ XE CƠ GIỚI (NHÓM XE)',
  },
  {
    value: 'MS11-BCVC',
    label: 'BÁO CÁO KẾT QUẢ KINH DOANH BẢO HIỂM VẬT CHẤT XE CƠ GIỚI',
  },
  {
    value: 'BC_TOTAL_YEAR_XECG',
    label: 'BÁO CÁO TỔNG HỢP NĂM XE CƠ GIỚI',
  },
  {
    value: '10B-MOF',
    label: 'BÁO CÁO THEO DÕI RIÊNG DOANH THU, CHI PHÍ TỪ HOẠT ĐỘNG KINH DOANH BẢO HIỂM BẮT BUỘC',
  },
  {
    value: 'TAT_XCG',
    label: 'Mẫu TAT xe cơ giới',
  },
  {
    value: 'RAW_XCG',
    label: 'Mẫu Uw raw xe cơ giới',
  },
  {
    value: 'ReportProductAnalysis',
    label: 'Báo cáo phân tích sản phẩm V2',
  },
  {
    value: 'TRAVEL_MATE',
    label: 'Báo cáo travel mate',
  },
  {
    value: 'BUSINESS_PROGRAM',
    label: 'Báo cáo chương trình kinh doanh',
  },
  {
    value: 'ReportProductCommit',
    label: 'Báo cáo tích chọn cam kết',
  },
  {
    value: 'ReportProductAnalysisPackage',
    label: 'Báo cáo phân tích sản phẩm V2 Package',
  },
]

export const InvoiceCustomerType = [
  {
    value: '0',
    label: 'Người mua',
  },
  {
    value: '1',
    label: 'Công ty-khác',
  },
  {
    value: '2',
    label: 'Cá nhân-khác',
  },
]

export const EndorReasons = [
  {
    value: 'DA',
    label: 'Điều chỉnh kê khai/ Declaration Adjustment',
    disable: true,
  },
  {
    value: 'UR',
    label: 'Thay đổi tỷ lệ phí/ Update premium rate',
  },
  {
    value: 'UC',
    label: 'Thay đổi điều khoản điều kiện/ Update Clauses - T&C',
  },
  {
    value: 'UP',
    label: 'Thay đổi người được bảo hiểm/ Update Insured Persons',
  },
  {
    value: 'AI',
    label: 'Thay đổi quyền lợi/ Update Items - Benefit To Risk',
  },
  {
    value: 'UL',
    label: 'Thay đổi địa chỉ/ Update Location',
  },
  {
    value: 'UI',
    label: 'Thay đổi Bên mua BH/Người được BH/ Update Policy Holder',
  },
  {
    value: 'US',
    label: 'Thay đổi số tiền bảo hiểm/ Update Sum Insured',
  },
  {
    value: 'YA',
    label: 'Điều chỉnh cuối năm/ Year-End Adjustment',
  },
  {
    value: 'RY',
    label: 'Hoàn phí do điều chỉnh cuối năm/ Refund - Year-End Adjustment',
  },
  {
    value: 'RT',
    label: 'Hoàn phí do chấm dứt đơn/ Refund- Terminate Policy',
  },
  {
    value: 'RB',
    label: 'Hoàn phí do điều khoản (GRR/No claim bonus)/ Refund-No Claim Bonus-GRR',
  },
  {
    value: 'RF',
    label: 'Hoàn phí/ Refund Fee',
  },
  {
    value: 'PW',
    label: 'Hủy đơn do không thanh toán/ Cancel - Premium Warranty',
  },
  {
    value: 'CI',
    label: 'Hủy đơn bởi Người được bảo hiểm/ Cancelled By Insured',
  },
  {
    value: 'CC',
    label: 'Hủy đơn bởi Công ty bảo hiểm/ Cancelled By Insurer',
  },
  {
    value: 'EX',
    label: 'Gia hạn hiệu lực/ Extend Expiry Date',
  },
  {
    value: 'RP',
    label: 'Thu hẹp hiệu lực/ Reduce Expiry Date',
  },
  {
    value: 'Y2',
    label: 'Post phí năm thứ 2/ Second Year Premium',
  },
  {
    value: 'PA',
    label: 'Thu thêm phí/ Additional Premium',
  },
  {
    value: 'IN',
    label: 'Thu phí kỳ tiếp theo/ Instalment - Add Premium',
  },
  {
    value: 'MD',
    label: 'Kê khai tháng/ Monthly Declaration',
  },
  {
    value: 'OF',
    label: 'Hủy phí nội bộ/ Offset fee',
  },
  {
    value: 'OR',
    label: 'Post lại phí sau khi hủy nội bộ/ Offset fee - Repost',
  },
  {
    value: 'ST',
    label: 'Khôi phục lại đơn/ Reinstatement',
  },
  {
    value: 'CP',
    label: 'Thay đổi kế hoạch trả phí/ Change Pay Plan',
  },
  {
    value: 'AB',
    label: 'Điều chỉnh môi giới - đại lý/ Adjust Broker - Agent',
  },
  {
    value: 'AD',
    label: 'Điều chỉnh tỷ lệ đồng/ Adjust Co-insurance',
  },
  {
    value: 'AP',
    label: 'Điều chỉnh tỷ lệ tái/ Adjust Re-insurance',
  },
]

export const InsuranceProduct = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: 'P_I',
    label: 'Bảo hiểm con người',
  },
  {
    value: 'AUTO_I',
    label: 'Bảo hiểm ô tô',
  },
  {
    value: 'MOTO_I',
    label: 'Bảo hiểm xe gắn máy',
  },
]

export const TimeTypeReport = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: 'effective',
    label: 'Ngày hiệu lực',
  },
  {
    value: 'mof',
    label: 'Ngày MOF',
  },
]

export const PaymentTimeType = [
  {
    value: '0',
    label: 'Không áp dụng kê khai',
  },
  {
    value: '1',
    label: '7 Ngày (Thu phí sau 30 ngày)',
  },
  {
    value: '3',
    label: 'Quý (Thu phí sau 30 ngày)',
  },
  {
    value: '6',
    label: 'Quý (Thu phí cuối thời hạn)',
  },
  {
    value: '12',
    label: 'Tháng (Thu phí cuối thời hạn)',
  },
]

export const NationType = [
  {
    label: 'J',
    value: 'J',
  },
  {
    label: 'Non-J',
    value: 'NonJ',
  },
]

export const PaymentTypeStep1 = [
  {
    value: '0',
    label: 'Thanh toán ngay',
  },
  {
    value: '1',
    label: 'Thanh toán theo kỳ',
  },
]

export const CalculationType = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: '1',
    label: 'Prorata',
  },
  {
    value: '2',
    label: 'Ngắn hạn',
  },
]

export const typeSendMail = [
  {
    id: '1',
    name: 'Mail thông báo tái tục',
    label: 'Mail thông báo tái tục',
    type: 'RenewMail',
    value: 'RenewMail',
  },
  {
    id: '2',
    name: 'Mail giấy chứng nhận',
    label: 'Mail giấy chứng nhận',
    type: 'CertificateMail',
    value: 'CertificateMail',
  },
  {
    id: '3',
    name: 'Mail kích hoạt tài khoản',
    label: 'Mail kích hoạt tài khoản',
    type: 'ActiveAccount',
    value: 'ActiveAccount',
  },
  {
    id: '4',
    name: 'Mail thẻ bảo lãnh',
    label: 'Mail thẻ bảo lãnh',
    type: 'CardMail',
    value: 'CardMail',
  },
]

export const YearNumber = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: '1',
    label: '1 năm',
  },
  {
    value: '2',
    label: '2 năm',
  },
  {
    value: '3',
    label: '3 năm',
  },
]

export const IsDeductibleTypes = [
  {
    value: '0',
    label: 'Không',
  },
  {
    value: '1',
    label: 'Có',
  },
]

export const VehicleGroupsCode = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: 'AUTO.8',
    label: 'Xe chở người',
  },
  {
    value: 'AUTO.9',
    label: 'Xe chở hàng',
  },
]

export const HouseType = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: '1',
    label: 'Chung cư',
  },
  {
    value: '2',
    label: 'Nhà liền kề',
  },
  {
    value: '3',
    label: 'Biệt thự',
  },
]

export const OwnerType = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: '1',
    label: 'Chủ sở hữu',
  },
  {
    value: '2',
    label: 'Người thuê nhà',
  },
]

export const BusinessHouseType = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: '1',
    label: 'Thương mại',
  },
  {
    value: '2',
    label: 'Dân cư',
  },
]

export const FireFightingType = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: '1',
    label: 'Có chữa cháy tự động',
  },
  {
    value: '2',
    label: 'Không có chữa cháy tự động',
  },
]

export const MucDichSD = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: '1',
    label: 'kinh doanh',
  },
  {
    value: '2',
    label: 'Không kinh doanh',
  },
]

export const MucLimit = [
  {
    value: 'Limit1',
    label: 'Limit1',
  },
  {
    value: 'Limit2',
    label: 'Limit2',
  },
  {
    value: 'Limit3',
    label: 'Limit3',
  },
  {
    value: 'Limit4',
    label: 'Limit4',
  },
  {
    value: 'Limit5',
    label: 'Limit5',
  },
  {
    value: 'Limit6',
    label: 'Limit6',
  },
  {
    value: 'Limit7',
    label: 'Limit7',
  },
  {
    value: 'Limit8',
    label: 'Limit8',
  },
  {
    value: 'Limit9',
    label: 'Limit9',
  },
  {
    value: 'Limit10',
    label: 'Limit10',
  },
  {
    value: 'Limit11',
    label: 'Limit11',
  },
]

export const TaxTypeAdminFee = [
  {
    value: 0,
    label: 'Không chịu thuế',
  },
  {
    value: 1,
    label: 'Chịu thuế',
  },
]

export const TaxType = [
  {
    value: 0,
    label: 'Không chịu thuế',
  },
  {
    value: 1,
    label: 'Chịu thuế',
  },
  {
    value: 2,
    label: 'Chịu thuế 0%',
  },
]

export const EngineType = [
  {
    value: 'All_GearBoxType',
    label: 'Tất cả',
  },
  {
    value: 'MT',
    label: 'Hộp số sàn',
  },
  {
    value: 'AT',
    label: 'Số tự động',
  },
]

export const FlueType = [
  {
    value: '0',
    label: 'Chọn',
  },
  {
    value: '1',
    label: 'Xe Xăng/Dầu',
  },
  {
    value: '2',
    label: 'Xe Điện',
  },
  {
    value: '3',
    label: 'Hybrid',
  },
]

export const EndorType = [
  {
    value: '1',
    label: 'SĐBS chào phí',
  },
  {
    value: '2',
    label: 'Kê khai tăng giảm người',
    note: 'Không chuyển về PA',
  },
  {
    value: '3',
    label: 'SĐBS hợp đồng',
  },
]

export const SellingContractRenewType = [
  {
    value: '0',
    label: 'Khác',
  },
  {
    value: '1',
    label: 'Đã gửi mail/sms',
  },
  {
    value: '2',
    label: 'Từ chối',
  },
  {
    value: '3',
    label: 'Đang tái tục',
  },
  {
    value: '4',
    label: 'Tái tục thành công',
  },
  {
    value: '5',
    label: 'Không đủ điều kiện',
  },
  {
    value: '6',
    label: 'Đang thanh toán',
  },
  {
    value: '7',
    label: 'Đã xem',
  },
  {
    value: '8',
    label: 'Hết hạn tái tục',
  },
]

export const CertificateManagerType = [
  {
    value: 0,
    label: 'Chọn',
  },
  {
    value: 1,
    label: 'Điều chyển',
  },
  {
    value: 2,
    label: 'Thu hồi',
  },
  {
    value: 3,
    label: 'Huỷ',
  },
  {
    value: 4,
    label: 'Hoàn trả',
  },
]

export const ReceiveType = [
  {
    value: 0,
    label: 'Chọn',
  },
  {
    value: 1,
    label: 'Đơn vị',
  },
  {
    value: 2,
    label: 'Cá nhân',
  },
]

export const TypeOfFee = [
  {
    value: 0,
    label: 'Chọn',
  },
  {
    value: 1,
    label: 'Ghi nhận doanh thu bán hàng',
  },
  {
    value: 2,
    label: 'Ghi nhận doanh thu thực thu',
  },
  {
    value: 3,
    label: 'Huỷ hợp đồng',
  },
]

export const PaymentType = [
  {
    value: 0,
    label: 'Chọn',
  },
  {
    value: 1,
    label: 'Thanh toán trực tuyến',
  },
  {
    value: 2,
    label: 'Offline',
  },
  {
    value: 3,
    label: 'Thanh toán qua lương',
  },
]

export const PaymentTypeEng = [
  {
    value: 0,
    label: 'Select',
  },
  {
    value: 1,
    label: 'Online',
  },
  {
    value: 2,
    label: 'Offline',
  },
  {
    value: 3,
    label: 'Salary',
  },
]

export const PaymentGatewayType = [
  {
    value: 0,
    label: '',
  },
  {
    value: 1,
    label: 'Vnpay',
  },
  {
    value: 2,
    label: 'Alepay',
  },
  {
    value: 3,
    label: 'Onepay',
  },
  {
    value: 4,
    label: 'Thanh toán qua lương',
  },
]

export const PaymentGatewayTypeEng = [
  {
    value: 0,
    label: '',
  },
  {
    value: 1,
    label: 'Vnpay',
  },
  {
    value: 2,
    label: 'Alepay',
  },
  {
    value: 3,
    label: 'Onepay',
  },
  {
    value: 4,
    label: 'Salary',
  },
]

export const BacklogType = [
  {
    value: 0,
    label: 'Chọn',
  },
  {
    value: 1,
    label: 'Phát sinh',
  },
  {
    value: 2,
    label: 'Bán hàng',
  },
]

export const CancelInvoiceType = [
  {
    value: 0,
    label: 'Không',
  },
  {
    value: 1,
    label: 'Có',
  },
]

export const TaxCancelType = [
  {
    value: 0,
    label: 'Không hoàn thuế',
  },
  {
    value: 1,
    label: 'Hoàn thuế',
  },
]

export const RequireType = [
  {
    value: 1,
    label: 'Khách hàng yêu cầu',
  },
  {
    value: 2,
    label: 'Công ty bảo hiểm',
  },
]

export const ContractCancelType = [
  {
    value: 0,
    label: 'Tiền mặt',
  },
  {
    value: 1,
    label: 'Chuyển khoản',
  },
  {
    value: 2,
    label: 'Công nợ khách hàng',
  },
]

// export const CustomerRelationship = items ? JSON.parse(items).filter((o: any) => o.type == 1) : []

export const CustomerRelationship = [
  {value: '0', label: 'Chọn mối quan hệ'},
  {value: '1', label: 'Bản thân'},
  {value: '2', label: 'Bố/Mẹ'},
  {value: '3', label: 'Vợ/Chồng'},
  {value: '4', label: 'Anh/chị/em'},
  {value: '5', label: 'Họ Hàng'},
  {value: '6', label: 'Bạn bè'},
  {value: '7', label: 'Khác'},
  {value: '8', label: 'Con'},
  {value: '9', label: 'Người giám hộ hợp pháp'},
]

export const ContractSimultaneouslyType = [
  {
    value: '0',
    label: 'Chưa xử lý',
  },
  {
    value: '1',
    label: 'Đã tiếp nhận',
  },
  {
    value: '2',
    label: 'Trả về',
  },
  {
    value: '3',
    label: 'Điều chuyển tiếp',
  },
  {
    value: '4',
    label: 'Vô hiệu',
  },
]

export const ContractStatusType = [
  {
    value: '0',
    label: 'Tất cả',
    labelEng: 'All',
  },
  {
    value: '1',
    label: 'Thông tin khách hàng',
    labelEng: 'Cusomter Info',
  },
  {
    value: '2',
    label: 'Chương trình bảo hiểm',
    labelEng: 'Business Program',
  },
  {
    value: '10',
    label: 'Đang chào phí',
    labelEng: 'Quotation',
  },
  {
    value: '11',
    label: 'Vượt phân cấp chào phí',
    labelEng: 'Need Refer',
  },
  {
    value: '12',
    label: 'Trình chào phí',
    labelEng: 'Refer',
  },
  {
    value: '13',
    label: 'Duyệt chào phí',
    labelEng: 'Approve Quoation',
  },
  {
    value: '14',
    label: 'Từ chối chào phí',
    labelEng: 'Reject Quotation',
  },
  {
    value: '15',
    label: 'Hủy chào phí',
    labelEng: 'Cancel Quotation',
  },
  {
    value: '16',
    label: 'Hoàn thành chào phí',
    labelEng: 'Complete Quotation',
  },
  {
    value: '17',
    label: 'Ký số chào phí',
    labelEng: 'Sign Quotation',
  },
  {
    value: '18',
    label: 'Khách hàng đồng ý chào phí',
    labelEng: 'Client Confirm',
  },
  {
    value: '20',
    label: 'Nhập đối tượng được bảo hiểm',
    labelEng: 'Insured List',
  },
  {
    value: '25',
    label: 'Báo cấp đơn',
    labelEng: 'Notice PM',
  },
  {
    value: '30',
    label: 'Tạo hợp đồng',
    labelEng: 'Create Contract',
  },
  {
    value: '31',
    label: 'Trình hợp đồng',
    labelEng: 'Refer Contract',
  },
  {
    value: '32',
    label: 'Duyệt hợp đồng',
    labelEng: 'Approve Contract',
  },
  {
    value: '33',
    label: 'Ký số hợp đồng,GCN',
    labelEng: 'Signed',
  },
  {
    value: '38',
    label: 'Trình thanh toán qua lương',
    labelEng: 'Refer Salary Paying',
  },
  {
    value: '39',
    label: 'Hoàn thành hợp đồng',
    labelEng: 'Compelete Contract',
  },
  {
    value: '40',
    label: 'Đang thanh toán',
    labelEng: 'Paying',
  },
  {
    value: '41',
    label: 'Thanh toán thành công',
    labelEng: 'Payment Success ',
  },
  {
    value: '42',
    label: 'Chấm dứt hợp đồng',
    labelEng: 'Terminate Contract',
  },
  {
    value: '43',
    label: 'Hủy hợp đồng',
    labelEng: 'Cancel Contract',
  },
]

export const ApprovalStatusType = [
  {
    value: 0,
    label: 'Tất cả',
  },
  {
    value: 1,
    label: 'Duyệt',
  },
  {
    value: 2,
    label: 'Từ chối',
  },
  {
    value: 3,
    label: 'Hủy trình',
  },
]

export const SellingCoInsuranceKind = [
  {
    value: 1,
    label: 'Ngoài',
  },
  {
    value: 2,
    label: 'Nội bộ',
  },
]

export const ReinsurancesKind = [
  {
    value: 1,
    label: 'Cố định',
  },
  {
    value: 2,
    label: 'Tạm thời',
  },
]

export const PartnerTypes = [
  {
    value: 0,
    label: 'Chọn',
  },
  {
    value: 1,
    label: 'Ngân hàng',
  },
  {
    value: 2,
    label: 'Nhà thuốc',
  },
  {
    value: 3,
    label: 'Showroom',
  },
  {
    value: 4,
    label: 'Tổ chức tài chính',
  },
  {
    value: 5,
    label: 'Đại lý cá nhân',
  },
  {
    value: 6,
    label: 'Đại lý tổ chức khác',
  },
]

export const tripNumber = [
  {value: '0', label: '1 chuyến'},
  {value: '1', label: 'Nhiều chuyến'},
]

export const typeExtraFee = [
  {value: '0', label: ' '},
  {value: '1', label: 'Tỷ lệ %/ tổng'},
  {value: '2', label: 'Tỷ lệ %/lần'},
  {value: '3', label: 'Quãng đường'},
  {value: '4', label: 'Rủi ro (theo danh mục)'},
  {value: '5', label: 'Tuổi tàu'},
  {value: '6', label: 'Số tiền'},
]
export const pricingType = [
  {value: '0', label: 'Khác'},
  {value: '1', label: 'Trọng tải(tấn)'},
  {value: '2', label: 'Số ghế ngồi'},
  {value: '3', label: 'Công suất máy'},
  {value: '4', label: 'Mức TN/Thuyền viên'},
  {value: '5', label: 'Mức TN'},
]

export const shipType = [
  {value: '0', label: 'Chọn'},
  {value: 'LOAI_TAU_001', label: 'Tàu khách'},
  {value: 'LOAI_TAU_002', label: 'Tàu hàng'},
  {value: 'LOAI_TAU_003', label: 'Sà lan'},
  {value: 'LOAI_TAU_004', label: 'Sà lan có gắn cẩu'},
  {value: 'LOAI_TAU_005', label: 'Tàu chở dầu, hàng hoá lỏng,...'},
  {value: 'LOAI_TAU_006', label: 'Tàu cá'},
  {value: 'LOAI_TAU_007', label: 'Tàu lai dắt'},
  {value: 'LOAI_TAU_008', label: 'Tàu công dụng đặc biệt'},
  {value: 'LOAI_TAU_009', label: 'Phà'},
]
